import axios from "axios";
export default {
  state: {
    access_token: localStorage.getItem("access_token") || null,
    profile: localStorage.getItem("profile") || null,
  },
  getters: {
    authenticated(state) {
      return state.access_token !== null;
    },
    profile(state) {
      return JSON.parse(state.profile);
    }
  },
  mutations: {
    SET_ACCESS_TOKEN(state, access_token) {
      state.access_token = access_token;
    },
    SET_PROFILE(state, profile) {
      state.profile = JSON.stringify(profile);
    },
  },
  actions: {
    async authorize({ commit, dispatch }, credentials){
      return await axios.post('/sign-in', credentials)
      .then(response => {
        return dispatch('attempt', response.data.access_token)
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async attempt({ commit, state }, access_token ) {
      if (access_token) {
        commit("SET_ACCESS_TOKEN", access_token);
      }

      if (!state.access_token) {
        return;
      }

      try {
        let profile = await axios.get("/profile")
        commit("SET_PROFILE", profile.data.data)
        
        return Promise.resolve(profile.data.data)
      } catch (e) {
        if (e.response.status == 401) {
          commit("SET_ACCESS_TOKEN", null)
        }
        return Promise.reject(e)
      }
    },
    async loadProfile(){
      return await axios.get('/profile')
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async updateProfile(_, formData){
      return await axios.post('/profile', formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async revokeToken({ commit }){
      return await axios.get('/sign-out')
      .then(response => {
        
        commit("SET_PROFILE", null);
        commit("SET_ACCESS_TOKEN", null);
        return Promise.resolve(response.status);
      })
      .catch(errors => {
        commit("SET_PROFILE", null);
        commit("SET_ACCESS_TOKEN", null);
        return Promise.reject(errors.response)
      })
    },
    async clearToken({ commit }){
      commit("SET_PROFILE", null);
      commit("SET_ACCESS_TOKEN", null);
    },
  },
};
